var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsDarkProceed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DF7F0C1B-C1E7-4F15-8DD9-631C3D05E488") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Dark-/-proceed"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.333333, 1.333333)",
    fillRule: "nonzero",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,0 C2.98,0 0,2.98 0,6.66666667 C0,10.3533333 2.98,13.3333333 6.66666667,13.3333333 C10.3533333,13.3333333 13.3333333,10.3533333 13.3333333,6.66666667 C13.3333333,2.98 10.3533333,0 6.66666667,0 Z",
    id: "Icon-Shape",
    strokeWidth: 1.13333333
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Icon-Path",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    points: "5.92592593 9.62962963 5.18518519 8.88888889 7.40740741 6.66666667 5.18518519 4.44444444 5.92592593 3.7037037 8.88888889 6.66666667"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDarkProceed);
export default __webpack_public_path__ + "static/media/icons-dark-proceed.7b9fe341364f006205fcaf4a13938005.svg";
export { ForwardRef as ReactComponent };